import { marked } from "marked"

export function Markdown({ text }: { text: string }) {
  return (
    <div
      className="prose prose-sm dark:prose-invert max-w-none text-xs leading-normal [&_table]:overflow-x-auto"
      dangerouslySetInnerHTML={{
        __html: marked.parse(text, { async: false }) as string,
      }}
    />
  )
}
